import { render, staticRenderFns } from "./productAnalysis.vue?vue&type=template&id=aa5c4ee2&scoped=true&"
import script from "./productAnalysis.vue?vue&type=script&lang=js&"
export * from "./productAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./productAnalysis.vue?vue&type=style&index=0&id=aa5c4ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5c4ee2",
  null
  
)

export default component.exports